var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAuditSubmitted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_12231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.137 120 120 93.137 120 60C120 26.863 93.137 0 60 0C26.863 0 0 26.863 0 60C0 93.137 26.863 120 60 120Z",
    fill: "#F3FCFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 64H42C40.896 64 40 64.896 40 66C40 67.104 40.896 68 42 68H78C79.104 68 80 67.104 80 66C80 64.896 79.104 64 78 64Z",
    fill: "#18CE99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4598 41.395L54.2248 48.159C54.6158 48.55 55.1268 48.745 55.6388 48.745C56.1508 48.745 56.6618 48.55 57.0528 48.159L70.7978 34.415C71.5788 33.634 71.5788 32.368 70.7978 31.587C70.0168 30.806 68.7498 30.806 67.9698 31.587L55.6388 43.917L50.2878 38.567C49.5068 37.786 48.2408 37.786 47.4588 38.567C46.6778 39.348 46.6788 40.615 47.4598 41.395Z",
    fill: "#18CE99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 26H74.259C70.628 22.302 65.58 20 60 20C54.42 20 49.373 22.302 45.741 26H35C31.691 26 29 28.691 29 32V88C29 91.309 31.691 94 35 94H85C88.309 94 91 91.309 91 88V32C91 28.691 88.309 26 85 26ZM60 24C68.822 24 76 31.178 76 40C76 48.822 68.822 56 60 56C51.178 56 44 48.822 44 40C44 31.178 51.178 24 60 24ZM87 88C87 89.103 86.103 90 85 90H35C33.897 90 33 89.103 33 88V32C33 30.897 33.897 30 35 30H42.706C40.996 32.946 40 36.355 40 40C40 51.028 48.972 60 60 60C71.028 60 80 51.028 80 40C80 36.355 79.004 32.946 77.294 30H85C86.103 30 87 30.897 87 32V88Z",
    fill: "#18CE99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 72H46C44.896 72 44 72.896 44 74C44 75.104 44.896 76 46 76H74C75.104 76 76 75.104 76 74C76 72.896 75.104 72 74 72Z",
    fill: "#18CE99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 80H50C48.896 80 48 80.896 48 82C48 83.104 48.896 84 50 84H70C71.104 84 72 83.104 72 82C72 80.896 71.104 80 70 80Z",
    fill: "#18CE99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_12231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAuditSubmitted);
export default __webpack_public_path__ + "static/media/icon-audit-submitted.e459ae112a9121287e739471cff17e01.svg";
export { ForwardRef as ReactComponent };